import { Plug, BrainCircuit, CalendarPlus, ChevronRight } from "lucide-react";

const STEPS = [
  {
    icon: Plug,
    number: "1",
    title: "Conectamos tus herramientas",
    text: "El sistema puede conectarse al calendario y al software de gestión dental de la clínica.",
    note: "No sustituimos tu software clínico ni modificamos tu proceso asistencial.",
  },
  {
    icon: BrainCircuit,
    number: "2",
    title: "La IA confirma y analiza",
    text: "La IA contacta con los pacientes, interpreta sus respuestas, detecta señales de riesgo y avisa a recepción cuando es necesario.",
  },
  {
    icon: CalendarPlus,
    number: "3",
    title: "Recuperamos los huecos",
    text: "Cuando alguien cancela, la lista de espera inteligente ofrece el hueco a pacientes disponibles y facilita la reprogramación.",
  },
];

const PROCESS_LINE = [
  "Reserva",
  "Confirmación",
  "Predicción de riesgo",
  "Intervención",
  "Reprogramación o rescate del hueco",
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold uppercase tracking-widest text-navy-light">
            Cómo funciona
          </p>
          <h2
            data-testid="how-title"
            className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-[2.6rem] lg:leading-[1.15]"
          >
            Tres pasos. Sin cambiar tu forma de trabajar.
          </h2>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {STEPS.map((step) => (
            <article
              key={step.number}
              data-testid={`how-step-${step.number}`}
              className="relative rounded-xl border border-[#E8EDF5] bg-platinum/50 p-7 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:bg-white hover:shadow-md"
            >
              <span className="absolute right-6 top-5 font-heading text-5xl font-extrabold text-navy/[0.07]">
                {step.number}
              </span>
              <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy">
                <step.icon className="h-5 w-5 text-white" strokeWidth={1.8} />
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-navy">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-steel">{step.text}</p>
              {step.note && (
                <p className="mt-4 rounded-lg border border-[#DDEAE2] bg-[#F2F9F5] p-3 text-xs font-medium leading-relaxed text-navy">
                  {step.note}
                </p>
              )}
            </article>
          ))}
        </div>

        <div
          data-testid="how-process-line"
          className="mt-14 flex flex-wrap items-center justify-center gap-y-3 rounded-xl border border-[#E8EDF5] bg-white px-6 py-6 shadow-sm"
        >
          {PROCESS_LINE.map((step, i) => (
            <span key={step} className="flex items-center">
              <span
                className={`rounded-full px-4 py-2 text-xs font-semibold sm:text-sm ${
                  i === PROCESS_LINE.length - 1
                    ? "bg-[#E7F4EC] text-recover"
                    : "bg-platinum text-navy"
                }`}
              >
                {step}
              </span>
              {i < PROCESS_LINE.length - 1 && (
                <ChevronRight className="mx-1.5 h-4 w-4 shrink-0 text-steel" />
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
